import React, {useState, useEffect} from 'react';
import s from '../CreateCashOrder/CreateCashOrder.module.css';
import {ErrorMessage, Field, Form, Formik} from 'formik';
import {CustomInput} from '../../../Components/Input';
import {validationFilterForm} from '../../../assets/utils/validation';
import addressStyle from '../../Cart/Cart.module.css';
import commonStyle from '../../../assets/common/CommonStyle.module.css';
import LightGreenButton from '../../../Components/Buttons/LightGreenButton';
import {useTranslation} from 'react-i18next';
import {
	useCreateCashOrderMutation,
	useEditCashOrderMutation,
	useGetAccountsListQuery,
} from '../../../redux/DepotSlice/depotCashierApi';
import {
	RequestCreateCashierOrderType,
	RequestEditCashierOrderType,
} from '../../../types/CashierSliceStateType';
import {toast} from 'react-toastify';
import {useNavigate} from 'react-router-dom';
import {handleApiCall} from '../../../assets/utils/utils';
import CustomSelect, {
	BaseOption,
} from '../../../Components/Select/CustomSelect';

const CreateEditCashForm = ({
	initialValues,
	title,
	handleClosePopup,
	type,
}: {
	initialValues: RequestCreateCashierOrderType | RequestEditCashierOrderType;
	title: string;
	handleClosePopup?: () => void;
	type: 'create' | 'edit';
}) => {
	const {t} = useTranslation();
	const navigate = useNavigate();
	const {data: accountsList} = useGetAccountsListQuery();

	const [createCashOrder] = useCreateCashOrderMutation();
	const [editCashOrder] = useEditCashOrderMutation();

	// Стан для кастомного селекту
	const [selectedAccount, setSelectedAccount] = useState<BaseOption | null>(
		null,
	);

	// Ініціалізуємо селект при завантаженні даних
	useEffect(() => {
		if (accountsList?.accounts) {
			if (initialValues?.account_id) {
				const account = accountsList.accounts.find(
					(acc) => +acc.id === +initialValues.account_id,
				);
				if (account) {
					setSelectedAccount({
						label: account.name,
						value: account.id,
					});
				}
			} else if (type === 'create') {
				// Для створення встановлюємо пусте значення
				setSelectedAccount(null);
			}
		}
	}, [accountsList, initialValues, type]);

	// Створюємо опції для селекту
	const accountOptions: BaseOption[] =
		accountsList?.accounts?.map((account) => ({
			label: account.name,
			value: account.id,
		})) || [];

	const handleSubmit = async (
		values: RequestCreateCashierOrderType | RequestEditCashierOrderType,
	) => {
		// Перевіряємо, чи обрано акаунт
		if (!selectedAccount?.value) {
			toast.error(t('Будь ласка, оберіть категорію оплати'));
			return;
		}

		const payload = {
			...values,
			account_id: selectedAccount.value,
			...(type === 'create'
				? {order_id: undefined}
				: {order_id: values.order_id!}),
		};
		await handleApiCall({
			apiCall: () =>
				type === 'create'
					? createCashOrder(payload as RequestCreateCashierOrderType)
					: editCashOrder(payload as RequestEditCashierOrderType),
			onSuccess: (data) => {
				if (data.approve) {
					navigate(`/cash_order_list`);
					handleClosePopup && handleClosePopup();
					toast.success(data.message.textmsg);
				}
			},
			onError: (error) => {
				toast.error(error);
			},
		});
	};
	return (
		<>
			<div className={s.title}>{title}</div>
			<div className={s.formContainer}>
				{type === 'edit' && handleClosePopup && (
					<button
						type="button"
						className={s.closeButton}
						onClick={handleClosePopup}
						aria-label={t('Закрити')}
					>
						×
					</button>
				)}
				<Formik
					enableReinitialize
					initialValues={initialValues}
					onSubmit={handleSubmit}
					validationSchema={validationFilterForm}
				>
					{({handleSubmit}) => {
						return (
							<Form className={addressStyle.addNew} onSubmit={handleSubmit}>
								<div className={s.addressForm}>
									<div className={s.addressFormRow}>
										<div className={s.addressFormColumn}>
											<div className={addressStyle.inputName}>
												{t('Оплата')}
											</div>
											<div>
												<CustomSelect
													value={selectedAccount}
													onChange={(newValue) => setSelectedAccount(newValue)}
													options={accountOptions}
													placeholder={t('Виберіть категорію')}
												/>
												<Field
													type="hidden"
													name="account_id"
													value={selectedAccount?.value || ''}
												/>
											</div>
										</div>
										<div className={s.addressFormColumn}>
											<div className={addressStyle.inputName}>
												{t('Сума оплати')}
											</div>
											<CustomInput
												name={'amount'}
												placeholder={t('Сума')}
												inputClassName={s.amountInput}
											/>

											<ErrorMessage
												name={'amount'}
												className={s.error}
												component={'div'}
											/>
										</div>
									</div>
									<div className={s.commentContainer}>
										<div className={addressStyle.inputName}>
											{t('Коментар')}
										</div>
										<CustomInput
											name={'comment'}
											placeholder={t('Введіть текст')}
											multiline
											rows={15}
											inputClassName={s.comment}
										/>
									</div>
									<div className={s.greenButtonWrapper}>
										<LightGreenButton
											text={type === 'create' ? t('Зберегти') : t('Редагувати')}
											type={'submit'}
										/>
									</div>
								</div>
							</Form>
						);
					}}
				</Formik>
			</div>
		</>
	);
};

export default CreateEditCashForm;
